module.exports = __webpack_public_path__ + "static/media/scalable.da099568.jpeg";